import { Grid as MuiGrid, GridProps as MuiGridProps } from '@mui/material';

export interface GridProps extends MuiGridProps {
  // Extend with custom props if needed
}

export const Grid = (props: GridProps) => {
  return <MuiGrid {...props} />;
};

// Export Grid item for convenience
export const GridItem = MuiGrid;

export default Grid;
